module.exports = __webpack_public_path__ + "assets/img/recommend_icon02.8a9c9728.png";